// La messagerie est passée à React (js/react/ecrans/Messages.jsx).
//
// Le routeur redessine tout l'écran à chaque changement d'adresse, y compris
// quand seul l'identifiant de conversation change : le composant est donc
// remonté à neuf, et n'a pas à surveiller ses propres paramètres.
//
// L'ancienne version (d'avant React) a été retirée le 20 octobre 2026 —
// archivée hors du dépôt : ~/Desktop/koinonia-archive-code-retire-2026-10-20.zip.
import { vueReact } from "../react/pont.jsx";
import Messages from "../react/ecrans/Messages.jsx";

export const rendre = vueReact(Messages);
